/**
 * Video DOM Render
 *
 * Small DOM helpers for hidden inputs and video picker markup maintenance.
 */

import { videoForm } from "./video-form";

function ensureRemovedAttachedVideosInput(container: HTMLElement | null | undefined): HTMLInputElement | null {
    if (!(container instanceof HTMLElement)) return null;

    const candidate = videoForm.getRemovedAttachedVideosInput(container);
    if (candidate instanceof HTMLInputElement) {
        return candidate;
    }

    container.insertAdjacentHTML("beforeend", '<input type="hidden" name="removed_attached_videos" value="[]">');

    const inserted = videoForm.getRemovedAttachedVideosInput(container);
    return inserted instanceof HTMLInputElement ? inserted : null;
}

export { ensureRemovedAttachedVideosInput };
